import requests from "./requests";
import * as movieSelectors from "./redux/movies/movies.selectors";
import * as seriesSelectors from "./redux/series/series.selectors";
import {
	fetchLatestMoviesAsync,
	fetchNetflixMoviesAsync,
	fetchTopRatedMoviesAsync,
	fetchUpcomingMoviesAsync,
} from "./redux/movies/movies.actions";
import {
	fetchNetflixSeriesAsync,
} from "./redux/series/series.actions";
const {
	fetchReleasedMoviesByOneMonth,
	fetchNetflixOriginals,
	fetchTopRated,
	fetchUpcomingMovies,
} = requests;

export const fetchMovieDataConfig = [
	{
		id: 2,
		thunk: fetchNetflixMoviesAsync,
		url: fetchNetflixOriginals,
		title: "PSFLIX Originals",
		genre: "psflix",
		selector: movieSelectors.selectNetflixMovies,
		isLarge: true,
	}
];

export const fetchSeriesDataConfig = [
	{
		id: 1,
		thunk: fetchNetflixSeriesAsync,
		url: fetchNetflixOriginals,
		title: "PSFLIX Originals",
		genre: "psflix",
		selector: seriesSelectors.selectNetflixSeries,
		isLarge: true,
	}
];

export const fetchPopularDataConfig = [
	{
		id: 0,
		thunk: fetchTopRatedMoviesAsync,
		url: fetchTopRated,
		title: "Top Rated in your country",
		genre: "toprated",
		selector: movieSelectors.selectTopRatedMovies,
	},
	{
		id: 1,
		thunk: fetchLatestMoviesAsync,
		url: fetchReleasedMoviesByOneMonth,
		title: "New on PSFLIX",
		genre: "newin",
		selector: movieSelectors.selectLatestMovies,
	},
	{
		id: 2,
		thunk: fetchUpcomingMoviesAsync,
		url: fetchUpcomingMovies,
		title: "Upcoming",
		genre: "upcoming",
		selector: movieSelectors.selectUpcomingMovies,
	},
];

export const genresList = [
	{
		id: 28,
		name: "Action",
	},
	{
		id: 12,
		name: "Adventure",
	},
	{
		id: 16,
		name: "Animation",
	},
	{
		id: 35,
		name: "Comedy",
	},
	{
		id: 80,
		name: "Crime",
	},
	{
		id: 99,
		name: "Documentary",
	},
	{
		id: 18,
		name: "Drama",
	},
	{
		id: 10751,
		name: "Family",
	},
	{
		id: 14,
		name: "Fantasy",
	},
	{
		id: 36,
		name: "History",
	},
	{
		id: 27,
		name: "Horror",
	},
	{
		id: 10402,
		name: "Music",
	},
	{
		id: 9648,
		name: "Mystery",
	},
	{
		id: 10749,
		name: "Romance",
	},
	{
		id: 878,
		name: "Science Fiction",
	},
	{
		id: 10770,
		name: "TV Movie",
	},
	{
		id: 53,
		name: "Thriller",
	},
	{
		id: 10752,
		name: "War",
	},
	{
		id: 37,
		name: "Western",
	},
	{
		id: 10759,
		name: "Action & Adventure",
	},
	{
		id: 10762,
		name: "Kids",
	},
	{
		id: 10763,
		name: "News",
	},
	{
		id: 10764,
		name: "Reality",
	},
	{
		id: 10765,
		name: "Sci-Fi & Fantasy",
	},
	{
		id: 10766,
		name: "Soap",
	},
	{
		id: 10767,
		name: "Talk",
	},
	{
		id: 10768,
		name: "War & Politics",
	},
];